const request = {
    invalid_input: 'ข้อมูลที่ป้อนไม่ถูกต้อง {{details}}',
    general: 'เกิดข้อผิดพลาดในการร้องขอ',
    range_not_satisfiable: 'ช่วงข้อมูลไม่ตรงตามข้อกำหนด',
    feature_not_supported: 'ฟีเจอร์นี้ไม่รองรับในสภาพแวดล้อมปัจจุบัน',
};
export default Object.freeze(request);
